import { Button } from '@mui/material';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import './error.scss';

function NotFound404() {
  return (
    <>
      <Helmet>
        <title>Page Not Found 404</title>
      </Helmet>
      <div className='error-container'>
        <img
          className='error-image'
          src='/svgs/404.png'
          alt='404 Not found'
        />
        <div className='error-message'>You&apos;ve wandered into unknown territory</div>
        <Button
          className='error-redirect-btn'
          href='/'
          variant='contained'
        >
          Head Back Home
        </Button>
      </div>
    </>
  );
}

NotFound404.displayName = 'NotFound404';
export default NotFound404;
